import { render, staticRenderFns } from "./task_sel.vue?vue&type=template&id=661ea91c&scoped=true"
import script from "./task_sel.vue?vue&type=script&lang=js"
export * from "./task_sel.vue?vue&type=script&lang=js"
import style0 from "./task_sel.vue?vue&type=style&index=0&id=661ea91c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ea91c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661ea91c')) {
      api.createRecord('661ea91c', component.options)
    } else {
      api.reload('661ea91c', component.options)
    }
    module.hot.accept("./task_sel.vue?vue&type=template&id=661ea91c&scoped=true", function () {
      api.rerender('661ea91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_sel.vue"
export default component.exports